const fillRemaining = (currentArray = [], dict = {}) => [
  ...currentArray,
  ...Object.values(dict)
    .map(element => {
      if (element?.isAdded) return null

      const mappedValue = {
        id: element?.id,
        name: element?.name,
        materials: element?.materialsDict ? Object.values(element?.materialsDict) : null,
      }
      return element?.materialsDict
        ? mappedValue
        : {
            ...element,
            ...mappedValue,
          }
    })
    .filter(Boolean),
]

export const setupScaleViewCards = (commoditiesData, customizedMaterialFields, priceSheet) => {
  // create dict with commodity and material information
  const activeCommoditiesDict = commoditiesData?.Items?.reduce((commodityDict, commodity) => {
    const materials = priceSheet?.entriesObj?.filter(material => material.commodityId === commodity.id)
    const activeMaterialsDict = materials?.reduce(
      (materialDict, material) => ({
        ...materialDict,
        [material.id]: {
          ...material,
          id: material.id,
          name: material.materialName,
        },
      }),
      {},
    )

    return {
      ...commodityDict,
      [commodity?.id]: {
        id: commodity?.id,
        name: commodity?.name,
        materialsDict: activeMaterialsDict,
      },
    }
  }, {})

  const formattedCommodities = customizedMaterialFields
    .map(commodity => {
      const commodityDictReference = activeCommoditiesDict[commodity?.id]
      if (!commodityDictReference) return undefined
      if (commodityDictReference.isAdded) return undefined

      commodityDictReference.isAdded = true
      const materials = commodity?.materials
        ?.map(material => {
          const materialDictReference = commodityDictReference?.materialsDict?.[material?.id]
          if (!materialDictReference) return undefined
          if (materialDictReference.isAdded) return undefined

          const mappedValue = {
            ...materialDictReference,
            id: material?.id,
            name: materialDictReference?.name,
            color: material?.color,
          }
          materialDictReference.isAdded = true
          return mappedValue
        })
        .filter(Boolean)

      return {
        id: commodity?.id,
        name: commodityDictReference?.name,
        color: commodity?.color,
        materials: fillRemaining(materials, commodityDictReference?.materialsDict),
      }
    })
    .filter(Boolean)

  return fillRemaining(formattedCommodities, activeCommoditiesDict)
}

export const formatData = commodities =>
  commodities.map(commodity => ({
    id: commodity?.id,
    color: commodity?.color || '',
    name: commodity?.name || '',
    materials: (commodity?.materials || []).map(material => ({
      id: material?.id,
      color: material?.color || '',
      name: material?.name || '',
    })),
  }))
